import React, { useEffect, useState } from 'react'
import { useQuery, gql, useApolloClient } from '@apollo/client'
import { withTranslation } from 'react-i18next'
import CustomLoader from '../components/Loader/CustomLoader'
// core components
import Header from '../components/Headers/Header'
import { getworkerassignedorder } from '../apollo'
import DataTable from 'react-data-table-component'
import orderBy from 'lodash/orderBy'
import { withRouter } from 'react-router-dom';
import { Container, Button, useTheme } from '@mui/material'
import { customStyles } from '../utils/ppbbtable'
import useGlobalStyles from '../utils/globalStyles'
import TableHeader from '../components/TableHeader'

const GET_WORDERORDERASSIGN = gql`${getworkerassignedorder}`

const PackageOrderList = props => {
  const { t, searchResult = [] } = props; // Accept searchResult as prop
  const globalClasses = useGlobalStyles()
  const [page, setPage] = useState(1);
  const [tableData, setTableData] = useState([])
  const [currentPage, setCurrentPage] = useState(page);
  const [totalRows, setTotalRows] = useState(0)
  const [perPage, setPerPage] = useState(10)
  const client = useApolloClient();

  const variables = {
    limit: perPage,
    skip: (page - 1) * perPage,
  };

  const {
    data,
    loading: loadingQuery,
    refetch,
    networkStatus
  } = useQuery(GET_WORDERORDERASSIGN, {
    fetchPolicy: 'network-only',
    variables,
    onCompleted: (data) => {
      if (data && data.getWorkerAssignedOrders) {
        setTableData(data.getWorkerAssignedOrders.orders || [])
        setTotalRows(data.getWorkerAssignedOrders.totalCount || 0)
      }
    },
    onError: error => {
      const isForbiddenError = error && error.graphQLErrors.some(err => err.extensions.code === 'FORBIDDEN');
      if (isForbiddenError) {
        localStorage.removeItem('user-native');
        localStorage.removeItem('restaurant_id');
        client.clearStore();
        props.history.push('/auth/login');
      }
    },
  })

  useEffect(() => {
    if (data) {
      setTableData(data.getWorkerAssignedOrders.orders)
      setTotalRows(data.getWorkerAssignedOrders.totalCount)
    }
  }, [data]);

  useEffect(() => {
    refetch({ limit: perPage, skip: (page - 1) * perPage })
  }, [page, perPage, refetch]);

  // Reset table to original data when search is cleared
  useEffect(() => {
    if (searchResult.length === 0) {
      refetch({ limit: perPage, skip: (page - 1) * perPage })
    }
  }, [searchResult, page, perPage, refetch]);

  const handlePerRowChange = (newPerPage) => setPerPage(newPerPage)
  const handlePageChange = (page) => {
    setPage(page)
    setCurrentPage(page)
  }

  const customSort = (rows, field, direction) => {
    const handleField = row => row[field] ? row[field].toLowerCase() : row[field]
    return orderBy(rows, handleField, direction)
  }

  const getOrderStatusWord = (statusNumber) => {
    const statusMap = {
      0: "INITIATED", 1: "CONFIRMED", 2: "PACKING", 3: "BILLING",
      4: "READY_FOR_DELIVERY", 5: "RIDER_ASSIGNED", 6: "OUT_FOR_DELIVERY",
      7: "DELIVERED", 8: "CANCELLED", 9: "FAILED_OUT_OF_STOCK",
      10: "FAILED_INVALID_DELIVERY_ADDRESS", 11: "FAILED",
    };
    return statusMap[statusNumber] || "N/A";
  };

  const columns = [
    { name: "Order ID", selector: '_id', style: { cursor: 'pointer', minWidth:"300px" } },
    { name: "Store Name", selector: 'localStore', cell: row => <>{row.localStore.join(', ')}</>, style: { cursor: 'pointer' } },
    { name: "Order Date", selector: 'orderDate', cell: row => <>{new Date(row.orderDate).toLocaleDateString()}</>, style: { cursor: 'pointer' } },
    { name: "Delivery Date", selector: 'deliveryDate', style: { cursor: 'pointer' } },
    { name: "Completion Time", selector: 'completionTime', style: { cursor: 'pointer' } },
    { name: "Items Count", selector: 'itemsCount', style: { cursor: 'pointer' } },
    { name: "Order Status", selector: 'orderStatus', cell: row => <>{getOrderStatusWord(row.orderStatus)}</>, style: { cursor: 'pointer' } },
    { name: 'Rejected', selector: 'isOrderRejected', cell: row => <>{row.isOrderRejected ? "True" : "False"}</>, style: { cursor: 'pointer' } },
    { name: "Order Amount", selector: 'orderAmount', style: { cursor: 'pointer' } },
    { name: t('Action'), cell: row => <>{actionButtons(row)}</> },
  ];

  const theme = useTheme();
  const actionButtons = row => (
    <Button
      size="20px"
      variant="contained"
      sx={{
        fontWeight: 'bold',
        backgroundColor: theme.palette.warning.dark,
        color: theme.palette.common.white,
        padding: 0,
        height: '15px',
        fontSize: '7px',
        '&:hover': {
          border: '2px solid #637BFE',
          color: theme.palette.warning.dark,
          backgroundColor: "white"
        }
      }}
      onClick={e => {
        e.preventDefault()
        localStorage.setItem('OrderData', JSON.stringify(row))
        props.history.push({ pathname: '/package_admin/OrderDetails', state: { id: row._id } })
      }}
    >
      {t('View Details')}
    </Button>
  );

  // Use searchResult if available, else default tableData
  const finalData = (searchResult && searchResult.length > 0) ? searchResult : tableData;

  return (
    <>
      <Header />
      <Container className={globalClasses.flex} fluid>
        {loadingQuery ? (
          <CustomLoader />
        ) : (
          <DataTable
            customStyles={customStyles}
            subHeader={true}
            title={<TableHeader title={t('All Order Details')} />}
            columns={columns}
            data={finalData}
            paginationDefaultPage={currentPage}
            paginationPerPage={perPage}  
            pagination
            paginationServer
            paginationTotalRows={totalRows}
            onChangeRowsPerPage={handlePerRowChange}
            onChangePage={handlePageChange}
            sortFunction={customSort}
            progressPending={loadingQuery || networkStatus === 4}
            progressComponent={<CustomLoader />}
          />
        )}
      </Container>
    </>
  )
}

export default withTranslation()(withRouter(PackageOrderList));
